import { Component, OnInit } from '@angular/core';

import { ApiService } from '../services/api.service';



interface EmployeeLocation {

  employeeId: number;

  employeeName: string;

  latitude: number;

  longitude: number;

  lastUpdated: string;

}



@Component({

  selector: 'app-employee-locations',

  templateUrl: './employee-locations.component.html',

  styleUrls: ['./employee-locations.component.scss']

})

export class EmployeeLocationsComponent implements OnInit {

  locations: EmployeeLocation[] = [];

  loading = false;

  error: string | null = null;



  // Map view defaults (centered roughly on Mogadishu; adjust as needed)

  mapLat = 2.0469;

  mapLng = 45.3182;

  // Slightly closer default zoom so employee markers are easier to see

  mapZoom = 15;



  constructor(private apiService: ApiService) {}



  ngOnInit(): void {

    this.loadLocations();

  }



  loadLocations(): void {

    this.loading = true;

    this.error = null;

    this.apiService.getLatestEmployeeLocations().subscribe({

      next: (resp) => {

        const list: EmployeeLocation[] = (resp?.locations || []).map((l: any) => ({

          employeeId: Number(l.employeeId ?? 0),

          employeeName: String(l.employeeName ?? ''),

          latitude: Number(l.latitude ?? 0),

          longitude: Number(l.longitude ?? 0),

          lastUpdated: String(l.lastUpdated ?? '')

        }));

        this.locations = list;

        if (list.length > 0) {

          // Center on the first employee location (simple & previously working)

          this.mapLat = list[0].latitude;

          this.mapLng = list[0].longitude;

        }

        this.loading = false;

      },

      error: () => {

        this.error = 'Unable to load employee locations.';

        this.loading = false;

      }

    });

  }



  /**

   * Returns the number of whole minutes since this location was last updated.

   * If the timestamp is invalid, returns -1.

   */

  getMinutesAgo(lastUpdated: string): number {

    if (!lastUpdated) {

      return -1;

    }

    const updated = new Date(lastUpdated);

    if (isNaN(updated.getTime())) {

      return -1;

    }

    const diffMs = Date.now() - updated.getTime();

    if (diffMs < 0) {

      return 0;

    }

    return Math.floor(diffMs / 60000);

  }

}

